export const QuestionsDialogContentStyles = {
  title: 'text-28px text-darkblue font-bold',
  container: 'relative top-1/4 px-2 py-7 sm:p-7 w-auto sm:w-600px',
  header: 'mb-5 flex justify-between flex-wrap',
  paragraph: 'mb-3 text-16px',
  languageSelectorContainer: 'w-max',
}
